import { TextField, InputAdornment, IconButton, FormControl, FormHelperText, Typography } from '@mui/material';
import UploadIcon from '@mui/icons-material/Upload';
import { useRef } from 'react';
import React from 'react';

const FileUpload = (props) => {
    const {
        controleId,
        comp,
        stateData: data,
        stateErrors: errors,
        isDisabled,
        onFileChange,
    } = props;

    const fontStyle = {
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, sans-serif',
    };

    const fileRef = useRef();

    return <>

        <FormControl fullWidth variant="outlined" error={errors[controleId] ? true : false} style={{ marginBottom: '16px' }}>
            <Typography variant="body1" sx={{ mb: 1, ...fontStyle }}>
                {comp.label} {comp.isRequired && <span style={{ color: 'red' }}>*</span>}
            </Typography>
            <input
                name={controleId}
                type="file"
                ref={fileRef}
                style={{ display: 'none' }}
                disabled={isDisabled}
                onChange={onFileChange}
            />
            <TextField
                variant="outlined"
                value={data[controleId] || ""}
                placeholder="Choose a file"
                disabled={isDisabled}
                InputProps={{
                    readOnly: true,
                    endAdornment: (
                        <InputAdornment position="end">
                            <IconButton disabled={isDisabled} onClick={() => fileRef.current.click()}>
                                <UploadIcon />
                            </IconButton>
                        </InputAdornment>
                    ),
                    sx: {
                        ...fontStyle,
                        backgroundColor: `${!data[controleId] ? "#f0f0f0" : "#ffffff"}`,
                    }
                }}
                onClick={() => !isDisabled && fileRef.current.click()}
                sx={{
                    ...fontStyle, "& .MuiFormLabel-asterisk": {
                        color: "red",
                    },
                }}
            />
            {errors[controleId] && <FormHelperText>{errors[controleId]}</FormHelperText>}
        </FormControl>
    </>
}

export default FileUpload;
